import { render, staticRenderFns } from "./viewprofile.vue?vue&type=template&id=6f465506&scoped=true&"
import script from "./viewprofile.vue?vue&type=script&lang=js&"
export * from "./viewprofile.vue?vue&type=script&lang=js&"
import style0 from "./viewprofile.vue?vue&type=style&index=0&id=6f465506&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f465506",
  null
  
)

export default component.exports